// extracted by mini-css-extract-plugin
module.exports = {"menu_item":"_037ab9ee","check":"_db9eef3b","active_folder":"_13bf9222","create_project":"_94dc5889","create_text":"_1b2c3383","inactive_folder":"_c6f0b1cb","loading":"_ef1e12b9"};